import React, { useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import api from "../services/api";
import { setPermissions } from "../store/slices/permissionsSlice";

export default function ProtectedRoute({ children, permission }) {
  const dispatch = useDispatch();
  const { list, loaded } = useSelector(state => state.permissions);

  const sessionData = JSON.parse(localStorage.getItem("userSession"));
  const now = Date.now();
  // const isExpired = sessionData && sessionData.expiry < now;

  const toastShownRef = useRef(false);

  // 🔄 Fetch permissions once
  useEffect(() => {
    if (!loaded) {
      api.get("/me/permissions")
        .then(res => {
          dispatch(setPermissions(res.permissions || []));
        })
        .catch(err => {
          localStorage.removeItem("userSession");
          window.location.href = "/";
        });
    }
  }, [loaded, dispatch]);

  // 🔐 Auth checks
  if (!sessionData) {
    return <Navigate to="/" replace />;
  }


  // if (isExpired) {
  //   localStorage.removeItem("userSession");
  //   return <Navigate to="/" replace />;
  // }

  if (!loaded) {
    return null; // or loader
  }

  // ⛔ Permission denied
  if (permission && !list.includes(permission)) {
    if (!toastShownRef.current) {
      toast.error("You are not allowed to access this page");
      toastShownRef.current = true;
    }
    return <Navigate to="/access-denied" replace />;
  }

  // ✅ Allowed
  return children;
}
